import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Observable, of, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'countdown'
})
export class CountdownPipe implements PipeTransform {


  /**
   * Gets the millisecond difference between a future date and now
   * @private
   * @param   futureDate: string
   * @returns number  milliseconds remaining
   */
  private getMsDiff = (futureDate: string): number => (+(moment(futureDate)) - moment.now());

  /**
   * Converts milliseconds to the
   *
   * @private
   * @param msRemaining
   * @returns null    when no time is remaining
   *          string  in the format `HH:mm:ss`
   */
  private msToTime(msRemaining: number): string {
    if (msRemaining < 0) {
      console.info('---', msRemaining);
      return '--';
    }
    const tmp = moment.duration(msRemaining, 'milliseconds');
    return (
      tmp.days() +
      ' days ' +
      tmp.hours() +
      ' hours ' +
      tmp.minutes() +
      ' mins ' +
      tmp.seconds() +
      ' s'
    );
  }

  /**
   * @param futureDate    should be in a valid Date Time format
   *                      e.g. YYYY-MM-DDTHH:mm:ss.msz
   *                      e.g. 2021-06-04T17:27:10.740z
   */
  public transform(futureDate: string): Observable<string> {
    /**
     * Initial check to see if time remaining is in the future
     * If not, don't bother creating an observable
     */
    if (!futureDate || this.getMsDiff(futureDate) < 0) {
      return of('--')
    }
    return timer(0, 1000).pipe(
      map(() => {
        return this.msToTime(this.getMsDiff(futureDate));
      })
    );
  }

}
